import React from "react";
import { Table, Tag, Empty } from "antd";

const LeadExportHistory = ({ logs = [], loading }) => {
  const columns = [
    { title: "Exported By", dataIndex: "exported_by_name", render: (v) => v || "-" },
    { title: "Date & Time", dataIndex: "created_at", render: (v) => (v ? new Date(v).toLocaleString() : "-") },
    {
      title: "Format",
      dataIndex: "format",
      width: 100,
      render: (v) => <Tag color={v === "csv" ? "blue" : "green"}>{(v || "").toUpperCase()}</Tag>,
    },
    { title: "Leads Exported", dataIndex: "row_count", width: 140 },
  ];

  return (
    <Table
      rowKey="id"
      dataSource={logs}
      loading={loading}
      columns={columns}
      locale={{ emptyText: <Empty description="No leads have been exported yet" /> }}
      pagination={{ pageSize: 10, showSizeChanger: false }}
    />
  );
};

export default LeadExportHistory;
